<template>
  <div class="form-row d-flex justify-content-end">
    <div class="form-group col-sm-3">
      <kez-input v-model="searchText" label/>
    </div>
    <div class="form-group col-sm-2">
      <label class="col-form-label"></label>
      <div>
        <button type="submit" class="btn btn-action" @click="search(searchText)">
          <i class="material-icons">search</i>
        </button>
        
        <button type="submit" class="btn btn-action" @click="refresh()">
          <i class="material-icons">clear</i>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import KezInput from "@/components/_forms/KezInput";
import KezConfirmModal from "@/components/_modals/KezConfirmModal";

export default {
  components: {
    KezInput,
    KezConfirmModal
  },
  props: {
    path: {
      type: String,
      required: true
    },
    parameters: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      searchText: null
    };
  },
  methods: {
    search() {
      this.$store.dispatch(`${this.path}/search`, this.searchText);
    },
    refresh() {
      this.$store.dispatch(`${this.path}/getList`, this.parameters);
    }
  }
};
</script>

<style>
</style>
